import React from "react";
import AllUsers from "../AllUsers";
import SearchBar from "../SearchBar";

const Home = () => {
  return (
    <div>
      <SearchBar />
      <AllUsers />
    </div>
  );
};

export default Home;
